import { Attr, HasOne, HasMany, Model } from 'spraypaint';

import { ApplicationRecord } from './application_record';

@Model()
export default class SearchReindexation extends ApplicationRecord {
  static jsonapiType = 'search_reindexations';
}
